import React from 'react';
import { useMap } from 'react-leaflet';
import { IconButton, Box, Divider } from '@mui/material';
import { AddOutlined, RemoveOutlined } from '@mui/icons-material';

export default function CustomZoomControl() {
    const map = useMap();

    const handleZoomIn = () => {
        map.setZoom(map.getZoom() + 1);
    };

    const handleZoomOut = () => {
        map.setZoom(map.getZoom() - 1);
    };

    return (
        <Box
            sx={{
                position: 'absolute',
                top: 12,
                left: 12,
                zIndex: 1001,
                display: 'flex',
                flexDirection: 'column',
                backgroundColor: '#fff',
                borderRadius: 2,
                boxShadow: 3,
                overflow: 'hidden',
            }}
        >
            <IconButton
                onClick={handleZoomIn}
                sx={{
                    padding: '6px',
                    '&:hover': {
                        backgroundColor: '#fff',
                    },
                }}
            >
                <AddOutlined/>
            </IconButton>
            <Divider/>
            <IconButton
                onClick={handleZoomOut}
                sx={{
                    padding: '6px',
                    '&:hover': {
                        backgroundColor: '#fff',
                    },
                }}
            >
                <RemoveOutlined/>
            </IconButton>
        </Box>
    );
}
